import React from "react";
import {
  ApolloClient,
  HttpLink,
  InMemoryCache,
  ApolloProvider,
} from "@apollo/client";
import { BrowserRouter as Router } from "react-router-dom";
import { CssBaseline } from "@material-ui/core";
import {
  createMuiTheme,
  ThemeProvider,
  responsiveFontSizes,
} from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import styled from "styled-components";
import Routes from "./Routes";
import InternalLink from "components/presentation/InternalLink";
import ExternalLink from "components/presentation/ExternalLink";

let link;

if (process.env.NODE_ENV === "production" || process.env.REACT_APP_USE_AWS) {
  link = new HttpLink({
    uri:
      "https://h68lzuobbk.execute-api.ap-northeast-1.amazonaws.com/dev/graphql",
    headers: {
      "x-api-key": "PNkTnPZnib6NVkVfVdbip62di9FuH74D3yGIsKvU",
    },
  });
} else {
  link = new HttpLink({
    uri: "http://localhost:3333/dev/graphql",
  });
}

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link,
});

const theme = responsiveFontSizes(
  createMuiTheme({
    typography: {
      fontSize: 12,
    },
  })
);

const Container = styled.div`
  padding: 20px 8px;
  @media only screen and (min-width: 600px) {
    padding: 20px;
  }
`;

const AppMenu = () => {
  return (
    <div>
      <InternalLink to="/">オペラ公演情報トップ</InternalLink> |{" "}
      <ExternalLink href="https://opera.capriccioso.info">
        原語 de オペラ
      </ExternalLink>
    </div>
  );
};

export default () => {
  return (
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Router>
            <CssBaseline />
            <AppMenu />
            <Container>
              <Routes />
            </Container>
          </Router>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </ApolloProvider>
  );
};
